export default function () {
}



// WEBPACK FOOTER //
// ./src/app/tenant/guest/form/resources/mounted.js